import axios from "axios";

// Backend API URL - defaults to localhost for development.
// Use ?? (nullish coalescing) so an empty string env var (set in Docker for same-origin)
// is preserved rather than replaced by the localhost fallback.
const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL ?? 'http://localhost:3001';

const RequestAccessToken = async () => {
    // Call backend API to get Azure OAuth token
    // Backend handles Azure credentials securely (not exposed in client)
    return axios.post(`${BACKEND_API_URL}/api/auth/token`, {}, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

const AccessTokenService = {
    requestAccessToken: RequestAccessToken
};

export default AccessTokenService;